import { render, staticRenderFns } from "./MatchCreate.vue?vue&type=template&id=221bd6de&scoped=true&"
import script from "./MatchCreate.vue?vue&type=script&lang=ts&"
export * from "./MatchCreate.vue?vue&type=script&lang=ts&"
import style0 from "./MatchCreate.vue?vue&type=style&index=0&id=221bd6de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221bd6de",
  null
  
)

export default component.exports